import { Box, Icon, Typography } from '@material-ui/core'
import { useNoDataStyles } from './styles'
import { useNoDataTranslation } from './translation'

const NoData = () => {
  const styles = useNoDataStyles()
  const translation = useNoDataTranslation()

  return (
    <Box className={styles.container}>
      <Icon className={styles.emptyIcon}>block</Icon>
      <Typography className={styles.emptyMessage}>{translation.empty}</Typography>
    </Box>
  )
}

export default NoData
